import { DEPLOY_VERSION, VERSION } from './config';
import { staging } from '../../../../libs/environment/src/lib/staging';
import type { Environment } from './environment.interface';

const S3Prefix = `accounts/staging/xf1LhmfWOgvea1GjN2YgNPFcqYXyDN/${DEPLOY_VERSION}`;

export const environment: Environment = {
  production: true,
  name: 'staging',
  baseUrl: staging.ssoUrl,
  S3Prefix: S3Prefix,
  deployUrl: `https://static-webapps.pipelinersales.com/${S3Prefix}`,
  apiPublicGqlUrl: staging.apiPublicGqlUrl,
  apiUserGqlUrl: staging.apiUserGqlUrl,
  pipelinerToken: null,
  crmAppUrl: staging.crmUrl,
  customerPortalUrl: staging.customerPortalUrl,
  businessCenterUrl: staging.businessCenterUrl,
  partnerPortalUrl: staging.partnerPortalUrl,
  version: VERSION,
  metrics: {
    sentryEnabled: true,
    firebase: {
      enabled: true,
      configData: {
        apiKey: 'AIzaSyClaqJctWRbnVSVusbYAmWSnTP2bNDLTVw',
        authDomain: 'pipeliner-mobile-app.firebaseapp.com',
        databaseURL: 'https://pipeliner-mobile-app.firebaseio.com',
        projectId: 'pipeliner-mobile-app',
        storageBucket: 'pipeliner-mobile-app.appspot.com',
        messagingSenderId: '1064196264335',
        appId: '1:1064196264335:web:a06dc1b43ff9d008523bfa',
        measurementId: 'G-KWZGZ9Q90P'
      }
    }
  },
  google: {
    client_id: '465908632677-moajra1preneha7aluk1u575tgvsbjvv.apps.googleusercontent.com'
  },
  ms: {
    client_id: '49e1667a-b28c-4936-aeaf-1a043c93cc93'
  },
  signUpUrl: staging.signUpUrl,
  toolsInWindow: true
};
